import classnames from 'classnames';
import { useRouter } from 'next/router';
import { useCallback } from 'react';
import { SimpleImage } from '@components/common/SimpleImage';
import { UiKitButton } from '@components/common/ui-kit-button';
import { ButtonGroup } from '@features/Unsubscribe/components/ButtonGroup';
import { Container } from '@features/Unsubscribe/components/Container';
import { Title } from '@features/Unsubscribe/components/Title';
import { useUnsubscribeAnalytics } from '@features/Unsubscribe/hooks/use-unsubscribe-analytics';
import type { TpWizardSteps } from '@features/Unsubscribe/types';
import { closeWebView } from '@features/Unsubscribe/utils/close-web-view';
import styles from './Sad.module.scss';
export const Sad = (props: TpWizardSteps) => {
  const {
    query
  } = useRouter();
  const {
    origin
  } = query;
  const {
    defaultEventOptions,
    trackUnsubscribeEvent
  } = useUnsubscribeAnalytics();
  const handleDone = useCallback(() => {
    trackUnsubscribeEvent('cancel_miss_you_done_tapped');
    if (origin === 'app') {
      closeWebView();
    } else {
      window.close();
    }
  }, [origin, trackUnsubscribeEvent]);
  return <Container className={styles.container} eventOnMounted="cancel_miss_you_opened" eventOptions={defaultEventOptions} data-sentry-element="Container" data-sentry-component="Sad" data-sentry-source-file="index.tsx">
      <div className={classnames('double-grow', styles.content)}>
        <div className={styles.imageWrapper}>
          <SimpleImage src="cancelling-sad.svg" layout="fill" alt="sad" data-sentry-element="SimpleImage" data-sentry-source-file="index.tsx" />
        </div>

        <Title className={styles.title} data-sentry-element="Title" data-sentry-source-file="index.tsx">Your subscription is canceled</Title>

        <p className={styles.description}>
          You won&apos;t be charged anymore. But you can always renew our
          subscription!
        </p>
      </div>
      <ButtonGroup data-sentry-element="ButtonGroup" data-sentry-source-file="index.tsx">
        <UiKitButton fullWidth className={styles.button} onClick={handleDone} data-sentry-element="UiKitButton" data-sentry-source-file="index.tsx">
          Done
        </UiKitButton>
      </ButtonGroup>
    </Container>;
};